<template>
  <BasePageContainer
    class="pt-10 px-2">
    <PageHeader
      has-back
      with-members>
      テスト成績管理
    </PageHeader>
    <template v-if="initialized">
      <AcademicRecordsForm
        v-if="academicRecord"
        ref="form"
        :academic-record="academicRecord"
        :existing-academic-records="academicRecords"
        :user-id="userId"
        @submit="onSubmit" />
      <div class="d-flex justify-content-start mt-4">
        <button
          type="button"
          class="btn d-block text-right text--grey09 d-flex align-items-center"
          @click="onClickDelete">
          <span class="material-icons mr-1">
            delete
          </span>
          削除する
        </button>
      </div>
    </template>
  </BasePageContainer>
</template>

<script>
import BasePageContainer from '@/components/parts/BasePageContainer.vue'
import PageHeader from '@/components/parts/PageHeader.vue'
import AcademicRecordsForm from '@/components/view/profile/academic_records/AcademicRecordsForm.vue'
import confirmIfFormChanged from '@/components/mixin/confirmIfFormChanged'
export default {
  components: {
    BasePageContainer,
    PageHeader,
    AcademicRecordsForm,
  },
  mixins: [confirmIfFormChanged()],
  data() {
    return {
      initialized: false,
      academicRecord: null,
      academicRecords: []
    }
  },
  computed: {
    userId() {
      return this.$route.params.id
    },
    academicRecordId() {
      return this.$route.params.academicRecordId
    }
  },
  async created() {
    this.$store.commit('startLoading')
    await Promise.all([
      this.fetchAcademicRecord(),
      this.fetchAcademicRecords(),
    ]).finally(() => {
      this.initialized = true
      this.$store.commit('finishLoading')
    })
  },
  methods: {
    async onSubmit(formData) {
      this.$store.commit('startLoading')
      this.postAcademicRecord(formData).then(() => {
        this.$store.commit('notify/set', {message: 'テスト成績を登録しました'})
        this.canLeave = true
        this.$nextTick(() => {
          this.$router.push(`/members/${this.userId}/profile`, { replace: true })
        })
      }).catch(() => {
        this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
      }).finally(() => {
        this.$store.commit('finishLoading')
      })
    },
    fetchAcademicRecord() {
      return this.$axios.get(`/profiles/academic-semesters/${this.academicRecordId}/`).then(res => {
        this.academicRecord = res.data
      })
    },
    fetchAcademicRecords() {
      return this.$axios.get('/profiles/academic-semesters/', {
        params: {
          user_id: this.userId,
        },
      }).then(res => {
        this.academicRecords = res.data.results
      })
    },
    postAcademicRecord(formData) {
      return this.$axios.post('/profiles/academic-semesters/', formData)
    },
    onClickDelete() {
      if (!window.confirm('この学年を削除してもよろしいですか？削除するとこの学年に入力した記録もすべて削除されます。')) return
      this.deleteAcademicRecord().then(() => {
        this.$store.commit('notify/set', {message: '学年を削除しました'})
        this.canLeave = true
        this.$nextTick(() => {
          this.$router.push(`/members/${this.userId}/profile`, { replace: true })
        })
      })
    },
    deleteAcademicRecord() {
      return this.$axios.delete(`/profiles/academic-semesters/${this.academicRecordId}/`)
    }
  }
}
</script>

<style>

</style>